<template>
  <detail-page>
    <template #title>
      <div class="title">
        <div class="text">{{ detail.title }}</div>
        <div class="time">{{ detail.time }}</div>
      </div>
    </template>
    <template #content>
      <div class="content">
        <div class="text" v-html="detail.content"></div>
      </div>
    </template>
  </detail-page>
</template>

<script>
import DetailPage from '@/views/pc/components/detailPage/Index.vue'

import { getNewsDetail } from '@/api/system.api.js'

export default {
  name: 'PcList',
  components: {
    DetailPage,
  },
  data() {
    return {
      detail: {},
    }
  },
  computed: {
    query() {
      return this.$route.query ? this.$route.query : {}
    },
    newsID() {
      return this.query.id
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    this.getDetail()
  },
  methods: {
    async getDetail() {
      await getNewsDetail({}, this.newsID)
        .then((res) => {
          if (res.data.id) {
            this.detail = {
              id: res.data.id,
              title: res.data.title,
              time: new Date(res.data.createtime * 1000).toLocaleDateString('zh-cn'),
              content: res.data.content,
            }
          } else {
            this.$router.push({ name: 'Pc404' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1000px;
  min-height: 156px;

  .text {
    margin-top: 58px;
    margin-bottom: 12px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #388176;
  }

  .time {
    margin-bottom: 15px;
    font-size: 16px;
    color: #8e8e8e;
  }
}

.content {
  margin: 0 auto;
  padding-top: 40px;
  width: 1000px;
  border-top: 1px solid #c3ad99;

  .text {
    line-height: 28px;
    font-size: 16px;
    color: #515151;
    white-space: pre-wrap;
    word-break: break-all;
  }

  ::v-deep video {
    margin: 4vw auto;
    width: 100%;
  }
  
  ::v-deep img {
    display: block;
    margin: 30px auto;
    max-width: 100%;
  }
}
</style>